import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { ShowToast } from '../../common/Toastr';
import { updateTimesheetPeriodAsync } from './timesheetSlice';

const DescriptionWidget = () => {
  const { accountEmployeeTimeEntryPeriodId, periodDescription, isLocked } = useAppSelector((state) => state.timesheet);
  const dispatch = useAppDispatch();
  const [description, setDescription] = useState(periodDescription);

  useEffect(() => {
    setDescription(periodDescription ?? "");
  }, [accountEmployeeTimeEntryPeriodId]);

  const onDescriptionChange = (e: any) => {
    !isLocked && dispatch(updateTimesheetPeriodAsync({
      AccountEmployeeTimeEntryPeriodId: accountEmployeeTimeEntryPeriodId,
      Description: e.target.value
    }))
      .unwrap()
      .then((originalPromiseResult) => {
        ShowToast('Description Updated Successfully.', 'Success', 'success');
      })
      .catch((rejectedValueOrSerializedError) => {
        ShowToast('Error occured while updating Description. Please try again.', 'Error', 'error');
      });
  }

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setDescription(e.target.value);
  }

  return (
    <div className={"col-md-12 col-sm-12 col-xs-12"}>
      <div className={"portlet light portlet-fit portlet-datatable bordered"}>
        <div className={"portlet-body"} style={{ paddingBottom: "0px" }}>
          {/* {showDescription && <div className={"form-group"}>
            <textarea id="txtTimesheetDescription" onBlur={onDescriptionChange} defaultValue={periodDescription} className={"form-control"} rows={4} style={{ borderRadius: 0 }}>
            </textarea>
          </div>} */}
          <div className={"form-group"}>
            <textarea
              id="txtTimesheetDescription"
              readOnly={isLocked == false ? false : true}
              onChange={handleChange}
              onBlur={onDescriptionChange}
              // defaultValue={description}
              value={description ?? ""}
              className={"form-control"}
              rows={4}
              style={{ borderRadius: 0 }}>
            </textarea>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DescriptionWidget